import React from 'react';
import PropTypes from 'prop-types';

import routes from 'app/routes';
import IconWithText from 'components/Widgets/IconWithText';
import CoachIcon from 'components/Common/Coaches/Widgets/Icon/Index';

import Duration from './Duration';
import StartAt from './StartAt';
import Cost from './Cost';

export default function ProgramInfo({ record, session }) {
  return (
    <div className="scheduling-program-info">
      <div className="mb-4">
        Coaching program:
        {' '}
        <a href={routes.members.programs.show(record.attributes.program.id)}>
          {record.attributes.program.title}
        </a>
      </div>

      <CoachIcon
        coach={record.attributes.coach}
        wrapperClassName="mb-4"
      >
        <>
          <div className="small text-gray-800">Coach</div>

          <div className="fw-semibold">{record.attributes.coach.full_name}</div>

          <div className="small fw-light text-gray-700">
            Time Zone:
            {' '}
            {record.attributes.coach.time_zone_offset}
          </div>
        </>
      </CoachIcon>

      <Duration />

      {session && <StartAt session={session} />}

      <Cost />

      {session
        && (
        <IconWithText
          iconClassName="dot-icon"
          iconStyle={{ maskSize: '25%', backgroundColor: session.attributes.status_color }}
          iconBg="bg-gray-200"
          wrapperClassName="mb-4"
        >
          <>
            <div className="small text-gray-800">
              Status
            </div>

            <div className="fw-semibold text-gray-900">
              {session.attributes.status}
            </div>
          </>
        </IconWithText>
        )}
    </div>
  );
}

ProgramInfo.propTypes = {
  record: PropTypes.object.isRequired,
  session: PropTypes.object,
};

ProgramInfo.defaultProps = {
  session: null,
};
